<template lang="pug">
div
    h4.titulo-secao(v-if='mostrarTitulo') {{ $t('mensagens.territorio.arquivo.tituloProdutor') }}
    .card-upload
        .card-header
            i.el-icon-document.header-icon
            .header-text
                h4.header-title {{ $t('mensagens.territorio.arquivo.subTituloAr') }}
        
        UploadArquivo(
            @add='onAdd',
            @delete='onDelete',
            :options='items'
        )
            | {{ $t('mensagens.territorio.arquivo.arquivo') }}
</template>

<style scoped lang="scss">
.titulo-secao {
    font-weight: 700;
    color: #5a5a5a;
    margin-bottom: 16px;
}

.card-upload {
    background-color: white;
    border-radius: 8px;
    padding: 24px;
    min-height: 195px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid #e4e7ed;
    min-height: 345px;
}

.card-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 2px solid #f0f2f5;
}

.header-icon {
    font-size: 24px;
    color: var(--primary);
}

.header-text {
    flex: 1;
}

.header-title {
    color: #5a5a5a;
    font-weight: 600;
    font-size: 15px;
    margin: 0;
}
</style>

<script>
import UploadArquivo from './UploadArquivoAr.vue';

export default {
    components: {
        UploadArquivo
    },
    props: {
        items: {
            type: Array,
            default: () => []
        },
        mostrarTitulo: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        onAdd(file) {
            this.$emit('add', file);
        },
        onDelete(index) {
            this.$emit('delete', index);
        }
    }
};
</script>
